import React, { useMemo, useState } from 'react';

// import { TbDots } from 'react-icons/tb';

import classNames from 'classnames';

import type { RowType, TableField } from 'components-new/table/table';

// import Table from 'components-new/table/table';

// import Icon from 'components-new/icon/icon';
// import Typography from 'components-new/typography/typography';
import Banner from 'components-new/banner/banner';

import type { PeriodJobAssignmentDetails } from 'state/__generated__/tadaahAPI';
import Table from 'components-new/table/table';

import Typography from 'components-new/typography/typography';

import {
  // formatDateToLocaleNetherlands,
  formatDateNetherlandsShort,
} from 'utils/display-text-formatter';

import { createLocale } from 'locales';

import AssignmentOptions from './AssignmentOptions';

const periodJobsLocalize = createLocale('organisationPeriodJobsLocales');

interface AssignmentsTableProps {
  assignmentDetails: PeriodJobAssignmentDetails;
  className?: string;
}

type statusType = {
  title: string;
  variant:
    | 'neutral'
    | 'neutral-var'
    | 'warning'
    | 'warning-var'
    | 'success'
    | 'destructive';
  className?: string;
};

const AssignmentsTable: React.FC<AssignmentsTableProps> = (props) => {
  const { assignmentDetails, className } = props;

  const fields: TableField[] = [
    {
      name: 'status',
      sortable: false,
      title: periodJobsLocalize('status'),
    },
    { name: 'date', sortable: false, title: periodJobsLocalize('startDate') },
    {
      name: 'startTime',
      sortable: false,
      title: periodJobsLocalize('startTime'),
    },
    { name: 'endTime', sortable: false, title: periodJobsLocalize('endTime') },
    {
      name: 'freelancer',
      sortable: false,
      title: periodJobsLocalize('freelancer'),
    },
    { name: 'options', sortable: false, title: '' },
  ];

  const preparedData = useMemo(
    () =>
      assignmentDetails.assignments?.map((job) => {
        const getStatus: () => statusType = () => {
          if (job.cancelled)
            return {
              className: 'bg-[#E7E6E8]',
              title: periodJobsLocalize('cancelled'),
              variant: 'neutral',
            };
          if (job.expired)
            return {
              className: 'bg-destructive-100',
              title: periodJobsLocalize('expired'),
              variant: 'destructive',
            };
          if (job.refused)
            return {
              className: 'bg-[#FEE7CC]',
              title: periodJobsLocalize('refused'),
              variant: 'warning',
            };
          if (job.accepted)
            return {
              className: 'bg-[#DAF7F5]',
              title: periodJobsLocalize('accepted'),
              variant: 'success',
            };
          if (job.pending)
            return {
              className: 'bg-[#FEF7D3]',
              title: periodJobsLocalize('pending'),
              variant: 'neutral-var',
            };
          if (job.converted)
            return {
              title: periodJobsLocalize('converted'),
              variant: 'warning-var',
            };
          return { title: '', variant: 'warning' };
        };
        const jobStatus = getStatus();
        return {
          date: formatDateNetherlandsShort(job.date),
          endTime: job.end.slice(0, 5),
          freelancer: job.assigned_to?.name || '-',
          id: job.id,

          options: job.cancelled ? (
            <Typography variant="body-large-bold" as="p" className="ml-4">
              ---
            </Typography>
          ) : (
            <AssignmentOptions
              assignment={job}
              periodJobId={assignmentDetails?.id.toString()}
            />
          ),
          startTime: job.start.slice(0, 5),
          status: (
            <Banner
              title={jobStatus.title}
              variant={jobStatus.variant}
              className={classNames('w-fit px-3', jobStatus?.className)}
            />
          ),
        };
      }),
    [assignmentDetails?.assignments, assignmentDetails.id],
  );

  const [page, setPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);

  const totalPages = useMemo(() => {
    return Math.ceil(assignmentDetails.assignments.length / currentPageSize);
  }, [assignmentDetails.assignments.length, currentPageSize]);

  const start = (page - 1) * currentPageSize;
  const end = start + currentPageSize;

  const data: RowType[] = useMemo(() => {
    return preparedData.slice(start, end);
  }, [preparedData, start, end]);

  return (
    <div className={classNames('rounded-md border-[#E7E6E8]', className)}>
      <Table
        currentPage={page}
        totalPages={totalPages}
        hasNextPage={totalPages > page}
        hasPreviousPage={page > 1}
        pageSizeOptions={[5, 10, 50]}
        currentPageSize={currentPageSize}
        onNumberOfItemsPerPageChange={(n) => {
          setPage(1);
          setCurrentPageSize(n);
        }}
        fields={fields}
        data={data}
        onPageChange={(p) => setPage(p)}
        selectable={false}
        emptyStateProps={{
          errorText: periodJobsLocalize('noAssignmentFound'),
        }}
      />
    </div>
  );
};

export default AssignmentsTable;
